export default "__VITE_ASSET__BAkMQL9z__"